/* eslint-disable no-undef */

export default {
	name: "assign-sales-rep-to-customers-modal",
	props: ["heading", "modalId", "showModal"],
	emits: ["closeClicked", "salesRepSelected"],
	data() {
		return {
			salesReps: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			salesRepSearchQuery: null,
			userHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Email Address",
					field: "email"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loading: false
		};
	},
	methods: {
		getSalesReps(){
			this.loading = true;
			let request = {
				roleId: roleHelper.role.salesRep,
				isActive: true,
				searchText: this.salesRepSearchQuery
			};
			securityService.getAllInternalUsers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.salesReps = successResponse.data.result;
						this.salesReps = dataTableHelper.castFieldValues(this.salesReps);
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getSalesReps();
		},
		onSalesRepSelect(userId, firstName, lastName){
			var selectedSalesRep = {
				userId: userId,
				firstName: firstName,
				lastName: lastName
			};
			console.log("selectedSalesRep", selectedSalesRep);
			this.$emit("salesRepSelected", selectedSalesRep);
		},
		onModalCloseClick() {
			this.salesRepSearchQuery = null;
			this.getSalesReps();
			this.$emit("closeClicked", true);
		}
	},
	mounted: function () {
		this.getSalesReps();
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
